import domReady from "@wordpress/dom-ready";
import { createRoot } from "@wordpress/element";
import apiFetch from "@wordpress/api-fetch";
import PluginSettingsApp from "./PluginSettingsApp";
import "./style.scss";

domReady(() => {
    if (window.WPBean_PGS_Options?.nonce) {
        apiFetch.use(
            apiFetch.createNonceMiddleware(window.WPBean_PGS_Options.nonce),
        );
    }

    const el = document.getElementById("wpbean-pgs-setting-rule-app");

    if (!el) {
        console.warn("#wpbean-pgs-setting-rule-app not found.");
        return;
    }

    // Read the settings row ID from the mount element's data attribute.
    // The PHP page sets data-id="<?php echo $id; ?>" on the div.
    const id = parseInt(el.dataset.id, 10) || 0;

    const root = createRoot(el);
    root.render(<PluginSettingsApp id={id} />);
});
